module.exports = __webpack_public_path__ + "static/img/img_logo.fc2d615d.png";